import { render, staticRenderFns } from "./IletisimListesi.vue?vue&type=template&id=133e0dca&scoped=true&"
import script from "./IletisimListesi.vue?vue&type=script&lang=js&"
export * from "./IletisimListesi.vue?vue&type=script&lang=js&"
import style0 from "./IletisimListesi.vue?vue&type=style&index=0&id=133e0dca&lang=scss&scoped=true&"
import style1 from "./IletisimListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e0dca",
  null
  
)

export default component.exports